// Module
var code = `<customer-breadcrumbs mode="'GROUP'"></customer-breadcrumbs>
<customer-profile-header mode="'GROUP'"></customer-profile-header>
<section class="box">
  <sub-header header="'Signatures'"></sub-header>
  <form name="form">
    <table id="signatures-selection-table" class="table">
      <tbody class="tbody">
      <tr>
        <td class="label">
          Released by:
        </td>
        <td class="values">
          <select
                  ng-model="\$ctrl.signatures.releasedByName"
                  ng-options="u.fullName as u.fullName for u in \$ctrl.allUsers"
                  ng-required="false"
                  disabled>
          </select>
        </td>
      </tr>
      <tr>
        <td class="label">
          Prepared by:
        </td>
        <td class="values">
          <select
                  ng-model="\$ctrl.signatures.preparedByName"
                  ng-options="u.fullName as u.fullName for u in \$ctrl.users"
                  ng-required="false"
                  disabled>
          </select>
        </td>
      </tr>
      <tr>
        <td class="label">
          Checked by:
        </td>
        <td class="values">
          <select
                  ng-model="\$ctrl.signatures.checkedByName"
                  ng-options="u.fullName as u.fullName for u in \$ctrl.users"
                  ng-required="true">
          </select>
        </td>
      </tr>
      <tr>
        <td class="label">
          Approved by:
        </td>
        <td class="values">
          <select
                  ng-model="\$ctrl.signatures.approvedByName"
                  ng-options="u.fullName as u.fullName for u in \$ctrl.users"
                  ng-required="true">
          </select>
        </td>
      </tr>
      </tbody>
    </table>

    <report-view report-content="\$ctrl.reportContent" ng-if="\$ctrl.reportContent && \$ctrl.hasData"></report-view>
    <div class="buttons">
      <button id="preview" class="btn btn-primary"
              ng-click="\$ctrl.preview()"
              ng-disabled="form.\$invalid"
      >
        Preview
      </button>
      <button class="btn btn-success"
              ng-disabled="!\$ctrl.reportContent"
              ng-click="\$ctrl.print()">
        Print
      </button>
      <button id="modalDownload" class="btn btn-primary"
              ng-click="\$ctrl.downloadXls()"
              ng-disabled="form.\$invalid"
      >
        Download XLS
      </button>
      <button id="modalClose" class="btn btn" data-dismiss="modal" aria-hidden="true"
              ng-click="\$ctrl.close()">
        Cancel
      </button>
    </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/group-loans-disbursment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;